/**
 * CargaResponsavel
 * @author Simpli CLI generator
 */
import {$, Helper, Request, Resource} from 'simpli-web-sdk'
import {ResponseSerialize} from 'simpli-web-sdk'
import {Carga} from '@/model/resource/Carga'
import {Endereco} from '@/model/resource/Endereco'
import {Responsavel} from '@/model/resource/Responsavel'
import {ResponsavelFilial} from '@/model/resource/ResponsavelFilial'
import {CargaResponsavelCollection} from '@/model/collection/CargaResponsavelCollection'

/* TODO: review generated class */
export class CargaResponsavel extends Resource {
  @ResponseSerialize(Carga)
  carga: Carga | null = null

  @ResponseSerialize(Endereco)
  endereco: Endereco | null = null

  @ResponseSerialize(Responsavel)
  responsavel: Responsavel | null = null

  @ResponseSerialize(ResponsavelFilial)
  responsavelFilial: ResponsavelFilial | null = null

  ehEmbarcador: boolean | null = null

  inscricaoEstadual: string | null = null
  substitutoTributario: string | null = null
  inscricaoMunicipal: string | null = null
  municipioIcms: string | null = null
  cnaeFiscal: string | null = null
  codigoRegimeTributario: string | null = null
  idFilialFk: number | null = null

  get $id() {
    /* TODO: define the ID */
    return 0
  }
  set $id(val) {
    /* TODO: define the ID */
  }

  get idCargaFk() {
    if (!this.carga) return 0
    return this.carga.$id
  }
  set idCargaFk(val) {
    if (!this.carga) this.carga = new Carga()
    this.carga.$id = val
  }

  get idResponsavelFk() {
    if (!this.responsavel) return 0
    return this.responsavel.$id
  }
  set idResponsavelFk(val) {
    if (!this.responsavel) this.responsavel = new Responsavel()
    this.responsavel.$id = val
  }

  get idEnderecoFk() {
    if (!this.endereco) return 0
    return this.endereco.$id
  }
  set idEnderecoFk(val) {
    if (!this.endereco) this.endereco = new Endereco()
    this.endereco.$id = val
  }

  /**
   * Gets a instance of a given ID of CargaResponsavel
   */
  async getCargaResponsavel(id1: number, id2: boolean) {
    return await Request.get(`/admin/carga-responsavel/${id1}/${id2}`)
      .name('getCargaResponsavel')
      .as(this)
      .getData()
  }

  /**
   * Lists the instances of CargaResponsavel
   */
  static async listCargaResponsavel(params: any) {
    return await Request.get(`/admin/carga-responsavel`, {params})
      .name('listCargaResponsavel')
      .as(CargaResponsavelCollection)
      .getData()
  }

  /**
   * Persists a new instance of CargaResponsavel. Use ID = 0 to create a new one,
   * or ID > 0 to update a current one
   */
  async persistCargaResponsavel() {
    return await Request.post(`/admin/carga-responsavel`, this)
      .name('persistCargaResponsavel')
      .asNumber()
      .getData()
  }

  /**
   * Lists the instances of CargaResponsavel to use it in a CSV file
   */
  static async listCsvCargaResponsavel(params: any) {
    return await Request.get(`/admin/carga-responsavel/csv`, {params})
      .name('listCsvCargaResponsavel')
      .as(CargaResponsavelCollection)
      .getData()
  }
}
